<template>
  <v-layout row wrap class="px-1">
    <!-- <v-flex xs12 class="px-5"> -->
    <!-- </v-flex> -->
    <v-flex xs12 class="pt-1 px-5">
      <template>
        <v-simple-table fixed-header class="spending-table nav-table">
          <template v-slot:default>
            <VuePerfectScrollbar
              class="drawer-menu--scroll"
              :settings="scrollSettings"
            >
              <thead>
                <tr>
                  <th class="f-14">Date</th>
                  <th class="f-14">Created By</th>
                  <th class="f-14">
                    Budget Code - Budget Name
                  </th>
                  <th class="f-14">Status</th>
                </tr>
              </thead>
              <tbody v-if="historyBudget.length > 0">
                <tr v-for="(val, index) in historyBudget" :key="index">
                  <td class="fs-12">{{ val.created_at }}</td>
                  <td class="fs-12">
                    {{ val.user ? val.user.email : '-' }}
                  </td>
                  <td class="fs-12">
                    {{ val.budget ? val.budget.code : '-' }} -
                    {{ val.budget ? val.budget.name : '-' }}
                  </td>
                  <td class="text-capitalize fs-12">
                    {{ val.action }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="text-center fs-12">
                    No data displayed
                  </td>
                </tr>
              </tbody>
            </VuePerfectScrollbar>
          </template>
        </v-simple-table>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    historyBudget: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 260
      }
    };
  }
};
</script>
